import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "fullscreen-note-wrap"
}
const _hoisted_2 = {
  key: 2,
  class: "note-wrap"
}

import NoteEditorBar from '@/components/notes/NoteEditorBar';
import NoteEditor from '@/components/notes/NoteEditor';
import ElectronNoteHeader from '@/components/notes/ElectronNoteHeader';
import { ref, computed, watch, toRef } from 'vue';
import NoteEnhancingOverlay from '@/components/notes/NoteEnhancingOverlay';
import { useStore } from 'vuex';
import useCurrentRole from '@/utilities/composables/useCurrentRole';

const FINISH_TIMEOUT_RATE = 3000;


export default /*@__PURE__*/_defineComponent({
  __name: 'Note',
  props: {
  noteId: {
    type: String,
    required: true,
  },
  isElectron: {
    type: Boolean,
    required: false,
    default: false,
  },
  isQuickNote: {
    type: Boolean,
    required: false,
    default: false,
  },
  isInboxNote: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ['createNote', 'deleteNote', 'close'],
  setup(__props, { emit: __emit }) {

const store = useStore();
const { isGuestReader } = useCurrentRole();

const emit = __emit;

const props = __props;

const aiNoteGeneratingFinishedTimeout = ref();

const note = computed(() => store.getters.getNotes[props.noteId] || {});

const noteHasTranscript = computed(() => !!note.value.transcript);

const aiNoteGenerating = computed(() => store.getters.getAiNoteGenerating);

const otherQuickResourcesAreOn = computed(() => {
  return (store.getters.getQuickCardIsOn || store.getters.getQuickPage) && !isGuestReader.value;
});

const uploadPopupIsOn = computed(() => Object.keys(store.getters.getPageUploadPopup).length > 0);

const clearAiNoteGeneratingFinishedTimeout = () => {
  clearTimeout(aiNoteGeneratingFinishedTimeout.value);
  aiNoteGeneratingFinishedTimeout.value = null;
};

const emitCreateNote = (noteId: string) => {
  emit('createNote', noteId);
};

window.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  emit('close');
});

watch(aiNoteGenerating, (newValue) => {
  /**
   * When AI note generation finishes, we set a timeout
   * to show the finished message for a certain amount of time
   */
  if (!newValue) {
    aiNoteGeneratingFinishedTimeout.value = setTimeout(
      clearAiNoteGeneratingFinishedTimeout,
      FINISH_TIMEOUT_RATE
    );
  }
});

watch(toRef(props, 'noteId'), () => {
  clearAiNoteGeneratingFinishedTimeout();
});

return (_ctx: any,_cache: any) => {
  return (__props.isQuickNote)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["modal z-[101]", { 'z-[99]': otherQuickResourcesAreOn.value || uploadPopupIsOn.value }]),
        onMousedown: _cache[2] || (_cache[2] = (noteId) => emit('close', noteId))
      }, [
        _createElementVNode("div", {
          class: "w-[600px] h-[600px] border border-solid border-important-border rounded-lg overflow-hidden",
          onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createVNode(_unref(NoteEditor), {
            "note-id": __props.noteId,
            "is-quick-note": true,
            onCreateNote: emitCreateNote,
            onClose: _cache[0] || (_cache[0] = (noteId) => emit('close', noteId))
          }, null, 8, ["note-id"]),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              (aiNoteGenerating.value || aiNoteGeneratingFinishedTimeout.value)
                ? (_openBlock(), _createBlock(_unref(NoteEnhancingOverlay), {
                    key: 0,
                    finished: aiNoteGeneratingFinishedTimeout.value,
                    "transcript-available": noteHasTranscript.value
                  }, null, 8, ["finished", "transcript-available"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createTextVNode()),
          _createVNode(_unref(NoteEditorBar), {
            class: "sticky bottom-0",
            "note-id": __props.noteId,
            "is-quick-note": true
          }, null, 8, ["note-id"])
        ], 32)
      ], 34))
    : (__props.isElectron)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(ElectronNoteHeader)),
          _cache[5] || (_cache[5] = _createTextVNode()),
          _createVNode(_unref(NoteEditor), {
            "note-id": __props.noteId,
            "is-inbox-note": __props.isInboxNote,
            onCreateNote: emitCreateNote
          }, null, 8, ["note-id", "is-inbox-note"]),
          _cache[6] || (_cache[6] = _createTextVNode()),
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              (aiNoteGenerating.value || aiNoteGeneratingFinishedTimeout.value)
                ? (_openBlock(), _createBlock(_unref(NoteEnhancingOverlay), {
                    key: 0,
                    finished: aiNoteGeneratingFinishedTimeout.value,
                    "transcript-available": noteHasTranscript.value
                  }, null, 8, ["finished", "transcript-available"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _cache[7] || (_cache[7] = _createTextVNode()),
          _createVNode(_unref(NoteEditorBar), {
            class: "mx-auto sticky bottom-0 w-[700px]",
            "note-id": __props.noteId,
            "is-electron-quick-note": true
          }, null, 8, ["note-id"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(NoteEditorBar), {
            "note-id": __props.noteId,
            "is-inbox-note": __props.isInboxNote
          }, null, 8, ["note-id", "is-inbox-note"]),
          _cache[8] || (_cache[8] = _createTextVNode()),
          _createVNode(_unref(NoteEditor), {
            "note-id": __props.noteId,
            "is-inbox-note": __props.isInboxNote,
            onCreateNote: emitCreateNote
          }, null, 8, ["note-id", "is-inbox-note"]),
          _cache[9] || (_cache[9] = _createTextVNode()),
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              (aiNoteGenerating.value || aiNoteGeneratingFinishedTimeout.value)
                ? (_openBlock(), _createBlock(_unref(NoteEnhancingOverlay), {
                    key: 0,
                    finished: aiNoteGeneratingFinishedTimeout.value,
                    "transcript-available": noteHasTranscript.value
                  }, null, 8, ["finished", "transcript-available"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
}
}

})